import { MenuItemType } from './MenuItem';
import { css } from 'emotion';

import { colors, fonts } from '../../styles';

const color = (type: MenuItemType, active?: boolean) => {
  if (type === MenuItemType.DARK) {
    return colors.gray.dark;
  }

  if (type === MenuItemType.LIGHT) {
    if (active) {
      return 'white';
    }
    return colors.gray.light;
  }
};

export const menuItem = (
  type: MenuItemType,
  active?: boolean,
  external?: boolean
) => css`
  display: flex;
  align-items: center;
  color: ${color(type, active)};
  font-size: ${fonts.size.small};
  font-weight: ${active ? fonts.weight.bold : fonts.weight.regular};
  line-height: 14px;
  ${
    active &&
    external &&
    css`
    text-decoration: underline;
  `
  };
`;
